var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import style from './HeaderMenuList.module.scss';
import { useAperzaUserContext } from '../AperzaUserContext';
import { addUtmParam } from '../../utils/addUtmParam';
// <A /> component
export function HeaderMenuListItemLink(_a) {
    var _b, _c;
    var item = _a.item, rel = _a.rel, target = _a.target, dense = _a.dense, className = _a.className, onClick = _a.onClick, appendIcon = _a.appendIcon;
    var serviceType = useAperzaUserContext().serviceType;
    if (item) {
        if (item.url) {
            return (_jsxs("a", __assign({ className: clsx(style.menuLink, (_b = {}, _b[style.dense] = dense, _b), className), href: addUtmParam(item.url, 'header', serviceType), rel: rel, target: target, onClick: onClick }, { children: [item === null || item === void 0 ? void 0 : item.title, _jsx("div", __assign({ className: style.linkIcon }, { children: appendIcon !== null && appendIcon !== void 0 ? appendIcon : (!(item === null || item === void 0 ? void 0 : item.headline) ? _jsx(FontAwesomeIcon, { icon: faChevronRight }) : _jsx(_Fragment, {})) }))] })));
        }
        return (_jsxs("div", __assign({ "aria-hidden": "true", onClick: onClick, className: clsx(style.menuLink, (_c = {}, _c[style.dense] = dense, _c), className) }, { children: [item === null || item === void 0 ? void 0 : item.title, _jsx("div", __assign({ className: style.linkIcon }, { children: appendIcon !== null && appendIcon !== void 0 ? appendIcon : (!(item === null || item === void 0 ? void 0 : item.headline) ? _jsx(FontAwesomeIcon, { icon: faChevronRight }) : _jsx(_Fragment, {})) }))] })));
    }
    return _jsx(_Fragment, {});
}
// <LI /> component
export function HeaderMenuListItem(props) {
    var _a, _b;
    var item = props.item, bordered = props.bordered, className = props.className, children = props.children;
    return (_jsx("li", __assign({ className: clsx(style.menuListItem, (_a = {}, _a[style.headlineItem] = item === null || item === void 0 ? void 0 : item.headline, _a), (_b = {}, _b[style.bordered] = bordered, _b), className) }, { children: children !== null && children !== void 0 ? children : _jsx(HeaderMenuListItemLink, __assign({}, props)) })));
}
// <UL /> component
export function HeaderMenuList(_a) {
    var _b, _c;
    var grid = _a.grid, bordered = _a.bordered, children = _a.children;
    return (_jsx("ul", __assign({ className: clsx(style.menuUl, (_b = {}, _b[style.menuGridUl] = grid, _b), (_c = {}, _c[style.bordered] = bordered, _c)) }, { children: children })));
}
